import { Contact } from 'containers/Contact'

export default Contact
